import { render } from "./FormularioQuestaoAvaliacao.vue?vue&type=template&id=26a217f0&scoped=true"
import script from "./FormularioQuestaoAvaliacao.vue?vue&type=script&lang=js"
export * from "./FormularioQuestaoAvaliacao.vue?vue&type=script&lang=js"

import "./FormularioQuestaoAvaliacao.vue?vue&type=style&index=0&id=26a217f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a217f0"]])

export default __exports__